import { createSelector, DefaultProjectorFn, MemoizedSelector } from '@ngrx/store';

import { AppState } from '../../app.state';

import { SettingsPreferences, UnitsState } from './units.state';

export namespace UnitsSelectors {
  export const unitsState = (state: AppState): UnitsState => state.units;

  export function settingsPreferences(): MemoizedSelector<
    AppState,
    SettingsPreferences,
    DefaultProjectorFn<SettingsPreferences>
  > {
    return createSelector(unitsState, (state: UnitsState) => state.preferences);
  }

  export function isTemperatureMetricUnit(): MemoizedSelector<
    AppState,
    boolean,
    DefaultProjectorFn<boolean>
  > {
    return createSelector(
      unitsState,
      (state: UnitsState) => state.preferences.temperature === 'celsius'
    );
  }
  export function isVolumeMetricUnit(): MemoizedSelector<
    AppState,
    boolean,
    DefaultProjectorFn<boolean>
  > {
    return createSelector(
      unitsState,
      (state: UnitsState) => state.preferences.volume === 'cubicMeter'
    );
  }
  export function isPressureMetricUnit(): MemoizedSelector<
    AppState,
    boolean,
    DefaultProjectorFn<boolean>
  > {
    return createSelector(unitsState, (state: UnitsState) => state.preferences.pressure === 'bar');
  }

  export function isFlowRateMetricUnit(): MemoizedSelector<
    AppState,
    boolean,
    DefaultProjectorFn<boolean>
  > {
    return createSelector(
      unitsState,
      (state: UnitsState) => state.preferences.flowRate === 'literPerHour'
    );
  }

  export function isLoading(): MemoizedSelector<AppState, boolean, DefaultProjectorFn<boolean>> {
    return createSelector(unitsState, (state: UnitsState) => {
      const isSetLoading = state.setLoading;
      const isGetLoading = state.getLoading;
      const preferencesLoaded = Object.values(state.preferences).every((value) => value !== null);

      return isSetLoading || isGetLoading || !preferencesLoaded;
    });
  }
}
